import { Component, ContentChildren, QueryList, AfterContentInit, ViewEncapsulation, Input } from '@angular/core';
import {LuciAccordionPanelComponent} from './luci-accordion-panel/luci-accordion-panel.component';

@Component({
  selector: 'luci-accordion',
  templateUrl: './luci-accordion.component.html',
  styleUrls: ['./luci-accordion.component.scss']
})
export class LuciAccordionComponent implements AfterContentInit {
  @Input() expandAll: false;
  @ContentChildren(LuciAccordionPanelComponent) groups: QueryList<LuciAccordionPanelComponent>;
  accordionComp = [];
  init = false;

  ngAfterContentInit() {
    this.accordionComp = this.groups.map((ele) => ele);
    if (this.groups) {
      this.groups.changes.subscribe((comp) => {
        const childComp = comp.map((ele) => {
          if (!this.isLoadedComp(ele)) {
            ele.toggle.subscribe(() => {
              this.openGroup(ele);
            });
          }
          return ele;
        });
        this.accordionComp = childComp.map((ele) => ele);
      });
    }
    this.accordionAction();
  }

  isLoadedComp(ele) {
    let status = false;
    this.accordionComp.forEach((t) => {
      if (t.title && t.title === ele.title) {
        status = true;
        return;
      }
    });
    return status;
  }

  accordionAction() {
    // Set active to first element
    if (this.expandAll) {
      this.accordionComp.forEach((t) => {
        t.opened = true;
      });
    } else {
      this.accordionComp[0].opened = true;
    }
    this.accordionComp[0].opened = true;
    this.accordionComp.forEach((t) => {
      t.toggle.subscribe(() => {
        this.openGroup(t);
      });
    });
  }

  openGroup(group: LuciAccordionPanelComponent) {
    group.opened = !group.opened;
  }

  openPanel(group: LuciAccordionPanelComponent) {
    this.accordionComp.forEach((t) => t.opened = false);
    group.opened = true;
  }

}
